'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.setLandingURL = setLandingURL;
exports.setLandingTimestamp = setLandingTimestamp;
exports.getClientId = getClientId;
exports.prepareOfflineEventSession = prepareOfflineEventSession;

var _storage = require('./storage');

var _time = require('./time');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function shouldSetAttributionParams(currentLocation) {
    return !/thank-you/.test(currentLocation);
}

/**
 * set the sessions landing page URL
 */
function setLandingURL() {
    if (_storage.Storage.get('MMLandingURL') && shouldSetAttributionParams(document.location.href)) {
        return;
    }

    _storage.Storage.set('MMLandingURL', document.location.href, { expires: 30 });
}

/**
 * set the sessions landing timestamp
 */
function setLandingTimestamp() {
    if (_storage.Storage.get('MMLandingTimestamp') && shouldSetAttributionParams(document.location.href)) {
        return;
    }

    var setStorage = function setStorage(ts) {
        return _storage.Storage.set('MMLandingTimestamp', ts, { expires: 30 });
    };

    var timestamp = $('meta[name=request-timestamp]').attr('content');

    if (timestamp) {
        setStorage(timestamp);
    } else {
        console.warn('no SSI timestamp available, retrieving UTC time from time server');
        (0, _time.getTimeUTC)().then(setStorage).catch(function (err) {
            return console.error('error retrieving UTC time');
        });
    }
}

/**
 * get the current sessions' GA client ID
 * @param gaProperty: @{String} the ID of the GA property for which to get a clientID. If not given, will use the client
 * ID from the first tracker
 * @return @{Promise} resolving with the session Client ID (or null if no client ID resolved)
 */
function getClientId(gaProperty) {
    if (window.ga === undefined) throw new Error('google analytics must be loaded to get a clientID');

    var trackers = window.ga.getAll();

    return new _promise2.default(function (resolve, reject) {
        if (trackers.length === 0) {
            console.warn('ga has no trackers, creating a tracker in order to get client ID');

            window.ga(function (tracker) {
                var clientId = tracker.get('clientId');
                resolve(clientId);
            });
        }

        resolve(trackers.filter(function (t) {
            return !gaProperty || t.get('trackingId') === gaProperty;
        })[0].get('clientId'));
    });
}

/**
 * store the given clientId for offline session mapping
 * @param gaClientId
 * @param matchingParams
 */
function prepareOfflineEventSession(gaClientId) {
    var matchingParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var serviceUrl = 'https://et.forthepeople.com/sessions/store';
    var clientTimestamp = (0, _time.epoch)();
    var expirationTimestamp = clientTimestamp + 60 * 120; // 2hr expiry

    return $.ajax({
        type: 'POST',
        url: serviceUrl,
        contentType: 'application/json',
        data: (0, _stringify2.default)({
            gaClientId: gaClientId,
            clientTimestamp: clientTimestamp,
            expirationTimestamp: expirationTimestamp,
            matchingParams: matchingParams
        })
    });
}


//////////////////
// WEBPACK FOOTER
// ./~/@morgan-morgan/core/module/lib/attribution.js
// module id = 12
// module chunks = 2 3